import React, { forwardRef, MutableRefObject } from 'react';
import CardSmall from './CardSmall';
import CardStandard from './CardStandard';
import CardFeatured from './CardFeatured';
import CardStrip from './CardStrip';
import CardHero from './CardHero';
import CardLodge from './CardLodge';
import CardText from './CardText';
import CardPoster from './CardPoster';
import { CardProps, CardHeroProps, CardStripProps } from './types';

const cardVariants = {
  small: CardSmall,
  standard: CardStandard,
  featured: CardFeatured,
  strip: CardStrip,
  hero: CardHero,
  lodge: CardLodge,
  text: CardText,
  poster: CardPoster,
};

interface CardParentProps extends CardProps, CardHeroProps, CardStripProps {
  variant?:
    | 'small'
    | 'standard'
    | 'featured'
    | 'strip'
    | 'hero'
    | 'lodge'
    | 'text'
    | 'poster';
  // children?: React.ReactNode;
}

const Card = forwardRef(
  (
    { variant, children, ...props }: CardParentProps,
    ref?: MutableRefObject<any>,
    // @ts-ignore
  ) => React.createElement(cardVariants[variant], { ...props, ref }, children),
);

export default Card;
